import { Button, Grid, TextField } from "@mui/material"
import { withStyles } from "@mui/styles"
import { useEffect, useState } from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { Styles } from "src/styles/material-styles"
import SimpleAutoComplete from "src/components/auto-complete/autocomplete-dialog-with-z-index"
import SimpleCheckBox from "src/components/checkbox/check"
import ApiRag from "src/services/apiRag"
import { PapiroConsole } from "src/utils/papiroConsole"

const RagConfiguration = (props) => {
    const { classes, intl, llm, onShowNotification, onLoading } = props

    const embeddingprovideroptions = [
        { id: 1, name: "OpenAI" },
        { id: 2, name: "Google" },
        { id: 3, name: "Azure" },
        { id: 4, name: "Ollama" },
    ]

    const [item, setItem] = useState({
        id: null,
        llmid: llm.id,
        hirerid: llm.hirerid,
        isenabled: true,
        opensearchindexname: "",
        maxchunksize: 1000,
        chunkoverlap: 200,
        embeddingmodel: "text-embedding-3-small",
        embeddingprovider: { id: 1, name: "OpenAI" },
        embeddingproviderid: 1,
        maxcontextdocuments: 5,
        similaritythreshold: 0.75,
        enablehybridsearch: true,
        vectorsearchweight: 0.7,
        textsearchweight: 0.3,
        systemprompttemplate: "",
    })

    useEffect(() => {
        getItem()
    }, [])

    const getItem = async () => {
        onLoading(true)
        await ApiRag.get(`/rag/configuration/${llm.id}`)
            .then((response) => {
                if (response && response.data) {
                    if (response.data.data) {
                        let result = response.data.data
                        result.embeddingprovider = embeddingprovideroptions.find(option => option.id === result.embeddingprovider) || null

                        PapiroConsole.log('result get rag configuration')
                        PapiroConsole.log(result)

                        setItem(result)
                    } else {
                        setItem((prevItem) => ({
                            ...prevItem,
                            llmid: llm.id,
                            hirerid: llm.hirerid,
                            maxchunksize: null,
                            chunkoverlap: null,
                            embeddingmodel: "",
                            maxcontextdocuments: null,
                            similaritythreshold: null,
                            enablehybridsearch: true,
                            vectorsearchweight: null,
                            textsearchweight: null,
                        }))
                    }
                }
            }).catch((error) => {
                let message = intl.formatMessage({ id: "error.getting.rag.configuration" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                } else {
                    message = intl.formatMessage({ id: "process.error" })
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target
        setItem((prevItem) => ({
            ...prevItem,
            [name]: type === 'checkbox' ? checked : value,
        }))
    }

    const handleChangeNumber = (e) => {
        const { name, value } = e.target
        setItem((prevItem) => ({
            ...prevItem,
            [name]: value === "" ? null : Number(value),
        }))
    }

    const changeValues = (stateName, value) => {
        setItem((prevItem) => ({
            ...prevItem,
            [stateName]: value,
        }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        onLoading(true)
        // Submit logic here

        item.embeddingproviderid = item.embeddingprovider.id

        await ApiRag.put('/rag/configuration', item)
            .then((response) => {
                PapiroConsole.log('Rag configuration saved')
                PapiroConsole.log(response)
                onShowNotification(intl.formatMessage({ id: "rag.configuration.saved" }))
            }).catch((error) => {
                let message = intl.formatMessage({ id: "error.saving.rag.configuration" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                } else {
                    message = intl.formatMessage({ id: "process.error" })
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    return (
        <form className={classes.form} onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SimpleCheckBox
                        selected={item.isenabled ?? false}
                        changeSelect={changeValues}
                        name="isenabled"
                        stateName="isenabled"
                        label={intl.formatMessage({ id: "rag.enable" })}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.open-search-index-name" })}
                        name="opensearchindexname"
                        stateName="opensearchindexname"
                        value={item.opensearchindexname ?? ""}
                        onChange={handleChange}
                        fullWidth
                        required
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.max-chunck-size" })}
                        name="maxchunksize"
                        stateName="maxchunksize"
                        type="number"
                        value={item.maxchunksize ?? ""}
                        onChange={handleChangeNumber}
                        fullWidth
                        required
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.chunck-overlap" })}
                        name="chunkoverlap"
                        stateName="chunkoverlap"
                        type="number"
                        value={item.chunkoverlap ?? ""}
                        onChange={handleChangeNumber}
                        fullWidth
                        required
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.embedding-model" })}
                        name="embeddingmodel"
                        stateName="embeddingmodel"
                        value={item.embeddingmodel ?? ""}
                        onChange={handleChange}
                        fullWidth
                        required
                    />
                </Grid>

                <Grid item xs={12}>
                    <SimpleAutoComplete
                        selected={item.embeddingprovider ?? { id: 1, name: "OpenAI" }}
                        label={intl.formatMessage({ id: "rag.embedding-provider" })}
                        name="embeddingprovider"
                        stateName="embeddingprovider"
                        changeSelect={changeValues}
                        fullWidth
                        options={embeddingprovideroptions}
                        required
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.max-context-documents" })}
                        name="maxcontextdocuments"
                        stateName="maxcontextdocuments"
                        type="number"
                        value={item.maxcontextdocuments ?? ""}
                        onChange={handleChangeNumber}
                        fullWidth
                        required
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.similarity-threshold" })}
                        name="similaritythreshold"
                        stateName="similaritythreshold"
                        type="number"
                        value={item.similaritythreshold ?? ""}
                        onChange={handleChangeNumber}
                        fullWidth
                        required
                        inputProps={{
                            step: "0.01",
                            inputMode: "decimal"
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <SimpleCheckBox
                        selected={item.enablehybridsearch ?? false}
                        changeSelect={changeValues}
                        name="enablehybridsearch"
                        stateName="enablehybridsearch"
                        label={intl.formatMessage({ id: "rag.enable-hybrid-search" })}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.vector-search-weight" })}
                        name="vectorsearchweight"
                        stateName="vectorsearchweight"
                        type="number"
                        value={item.vectorsearchweight ?? ""}
                        onChange={handleChangeNumber}
                        fullWidth
                        required
                        inputProps={{
                            step: "0.01",
                            inputMode: "decimal"
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.text-search-weight" })}
                        name="textsearchweight"
                        stateName="textsearchweight"
                        type="number"
                        value={item.textsearchweight ?? ""}
                        onChange={handleChangeNumber}
                        fullWidth
                        required
                        inputProps={{
                            step: "0.01",
                            inputMode: "decimal"
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.system-prompt-template" })}
                        name="systemprompttemplate"
                        stateName="systemprompttemplate"
                        value={item.systemprompttemplate ?? ""}
                        onChange={handleChange}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Button
                        type='submit'
                        fullWidth
                        variant='contained'
                        color='primary'
                    >
                        {<FormattedMessage id="save" />}
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}

export default injectIntl(withStyles(Styles)(RagConfiguration))